module.exports = __webpack_public_path__ + "static/img/proj-pic-3.961556e6.png";